import { render, staticRenderFns } from "./memberwxdialog.vue?vue&type=template&id=4ccbb685&scoped=true"
import script from "./memberwxdialog.vue?vue&type=script&lang=js"
export * from "./memberwxdialog.vue?vue&type=script&lang=js"
import style0 from "./memberwxdialog.vue?vue&type=style&index=0&id=4ccbb685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccbb685",
  null
  
)

export default component.exports